module.exports = __webpack_public_path__ + "sansg/img/fly.54874023.png";